export default function ExchangeIcon({ size = 42 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="26" y="10.9997" width="12" height="4" transform="rotate(-180 26 10.9997)" fill="black" />
            <rect x="16" y="30.9997" width="12" height="4" fill="black" />
            <rect x="38" y="25" width="4" height="17" transform="rotate(-180 38 25)" fill="url(#paint0_linear_1523_557)" />
            <rect x="4" y="16.9997" width="4" height="17" fill="url(#paint1_linear_1523_557)" />
            <path d="M36 25C36 29.4183 32.4183 33 28 33" stroke="black" strokeWidth="4" />
            <path d="M6 17C6 12.5817 9.58172 9 14 9" stroke="black" strokeWidth="4" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.3132 6.24189L23.0713 2L20.2429 4.82843L24.4847 9.07031L20.2421 13.313L23.0705 16.1414L27.3132 11.8987L27.3139 11.8995L30.1424 9.07107L30.1416 9.07031L27.3132 6.24189Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.8294 35.9007L19.0713 40.1426L21.8997 37.3142L17.6578 33.0723L21.9005 28.8296L19.072 26.0012L14.8294 30.2438L14.8286 30.2431L12.0002 33.0715L12.001 33.0723L14.8294 35.9007Z"
                fill="black"
            />
            <defs>
                <linearGradient id="paint0_linear_1523_557" x1="40" y1="32.1923" x2="40" y2="42" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="paint1_linear_1523_557" x1="5.99999" y1="24.192" x2="5.99997" y2="33.9997" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}
